import PageHeader from "../../components/common/PageHeader";
import useBanner from "./hooks/useBanner";
import BannerTable from "./components/BannerTable";
import BannerMobileCard from "./components/BannerMobileCard";
import BannerForm from "./components/BannerForm";
import BannerEditModal from "./components/BannerEditModal";

const Banner = () => {
  const {
    showForm, setShowForm,
    showModal,
    banners,
    loading,
    bannerData,
    page, setPage,
    rowsPerPage,
    productSearch,
    productResults,
    loadingProducts,
    isMobile,
    paginatedData,
    handleProductInputChange,
    handleSelectProduct,
    handleRowClick,
    handleImageChange,
    handleChange,
    handleSubmit,
    handleToggleVisible,
    handleClose,
    getStatus,
    dateTemplate,
    API_BASE,
  } = useBanner();

  return (
    <div>

      <PageHeader
        showBackButton={true}
        backTo={-1}
        onBack={showForm ? () => setShowForm(false) : undefined}
        title={showForm ? "Add Banner" : "Banner"}
        subtitle={
          !showForm
            ? "Manage your promotional banners"
            : "Fill in the details to create a new banner"
        }
        action={
          !showForm && (
            <button
              onClick={() => {
                setShowForm(true);
                handleClose();
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 w-full md:w-auto"
            >
              + Create New Banner
            </button>
          )
        }
      />

      {showForm ? (
        <BannerForm
          bannerData={bannerData}
          productSearch={productSearch}
          productResults={productResults}
          loadingProducts={loadingProducts}
          handleImageChange={handleImageChange}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          handleProductInputChange={handleProductInputChange}
          handleSelectProduct={handleSelectProduct}
          API_BASE={API_BASE}
        />
      ) : isMobile ? (
        <BannerMobileCard
          paginatedData={paginatedData}
          banners={banners}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          onCardClick={handleRowClick}
          dateTemplate={dateTemplate}
          getStatus={getStatus}
          API_BASE={API_BASE}
        />
      ) : (
        <BannerTable
          banners={banners}
          loading={loading}
          onRowClick={handleRowClick}
          onToggleVisible={handleToggleVisible}
          dateTemplate={dateTemplate}
          getStatus={getStatus}
          API_BASE={API_BASE}
        />
      )}

      <BannerEditModal
        open={showModal}
        onClose={handleClose}
        bannerData={bannerData}
        handleImageChange={handleImageChange}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        productSearch={productSearch}
        productResults={productResults}
        loadingProducts={loadingProducts}
        handleProductInputChange={handleProductInputChange}
        handleSelectProduct={handleSelectProduct}
      />
    </div>
  );
};

export default Banner;
